<template>
	<div :class='{"pc":!flag == true,"mobile":!flag == false}'>		
		<div class="infoBox">
			<img style='margin-bottom:70px' src="../assets/title-lmqd.png" alt="">
			<img src="../assets/chengguo.jpg" alt="">
			<div class="info">
				原农业部党组成员、国务院参事室特约研究员、中国农产品市场协会会长 张玉香，广东省农业农村厅 副厅长（正厅职）陈东与多个发起单位启动广东特色农产品区域公用品牌发展联盟，启动广东农业品牌目录制度建设，共同携手、共享资源，将“粤字号”农业品牌推向新的高度。
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		name: 'app',
		data() {
			return {
				flag: navigator.userAgent.match(
					/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
				)
			}
		},		
		methods: {
			
		},
		mounted() {
		
		}
	}
</script>

<style lang="scss" scoped="scoped">
	.pc{
		background: url('../assets/pbg.png');
		.infoBox{
			padding-top: 270px;
			img{
				display: block;
				margin: 0 auto;
			}
			.info{
				margin: 0 auto;
				margin-top: 20px;
				margin-bottom: 80px;
				width: 800px;
				font-size: 18px;
				line-height: 34px;
				text-indent: 40px;
				text-align: justify;
			}
		}
	}
	.mobile {
		width: 100%;
		height: 100%;
		margin-top: 1.302083rem;
		position: relative;
		overflow: hidden;
		.infoBox{
			padding: 10px;
			margin-top: 100px;
			font-size: 18px;
			line-height: 34px;
			text-align: justify;			
			img{
				width: 100%;
			}
			.info{
				text-indent: 40px;
				margin-bottom: 40px;
				margin-top: 18px;
				padding-bottom: 100px;
			}
		}
	}
</style>
